import {useEffect} from 'react'

import PropTypes from 'prop-types'

import {useRouter} from '@s-ui/react-router'

import {ROUTE_IDS} from '../../config/index.js'
import DetailLegacy from './variants/legacy/index.js'
import DetailNew from './variants/new/index.js'
import {getInitialProps} from './getInitialProps.js'
import Skeleton from './Skeleton.js'

// Plain CSS, kept out of every index.scss on purpose: DS stylesheets are listed
// in sui-bundler.plainCssPackages and must not go through the sass loaders.
import './styles/ui.css'

const Detail = props => {
  const {isAdDetailRevampEnabled} = props

  const router = useRouter()

  // The route is matched by url before the flag is known. WebVitalsReporter reads `route.id` when it reports
  // (this effect runs before its own), so swapping the id here makes the performance dashboards split by variant.
  useEffect(() => {
    // `router.routes` is the matched-route list of the legacy router; the RR7 shim does not expose it.
    // Reading `.length` of undefined here crashed every ad detail right after hydration.
    const route = router.routes?.[router.routes.length - 1]
    const isCochesDetailRoute = [ROUTE_IDS.AD_DETAIL_COCHES, ROUTE_IDS.AD_DETAIL_COCHES_REVAMP].includes(route?.id)
    if (!isCochesDetailRoute) return
    route.id = isAdDetailRevampEnabled ? ROUTE_IDS.AD_DETAIL_COCHES_REVAMP : ROUTE_IDS.AD_DETAIL_COCHES
  }, [isAdDetailRevampEnabled, router])

  const Component = isAdDetailRevampEnabled ? DetailNew : DetailLegacy

  return <Component {...props} />
}

Detail.propTypes = {
  isAdDetailRevampEnabled: PropTypes.bool
}

Detail.renderLoading = () => <Skeleton />
Detail.displayName = 'Detail'
Detail.getInitialProps = getInitialProps

export default Detail
